import { ArrowUpRight, Check } from "lucide-react";
import PageShell from "./PageShell";
import PageHero from "./PageHero";
import Reveal from "./Reveal";
import RelatedPages from "./RelatedPages";
import PullQuote from "./PullQuote";
import { ORIG } from "../mock";

const arts = {
  intro: "Our dedicated Cultural Hub — an entire building devoted to music, dance, theatre and the visual arts — stands on the belief that expression is as essential as equation.",
  pillars: [
    { title: "Music", body: "Western and Indian classical music programmes with individual practice rooms, recording studio and recital halls." },
    { title: "Dance", body: "Indian classical, contemporary and Western forms taught by professional choreographers." },
    { title: "Theatre", body: "A purpose-built amphitheatre and drama programme that builds confidence, voice and stage presence." },
    { title: "Visual Arts", body: "Painting, sculpture and pottery studios with abundant natural light and resident artists." },
    { title: "Public Speaking", body: "Debate, declamation and Model United Nations — because every child has a voice worth hearing." },
    { title: "Festivals & Showcases", body: "Annual day, cultural fests and inter-house competitions ensure every child performs." },
  ],
};

export default function ArtsPage() {
  return (
    <PageShell>
      {({ openEnquire }) => (
        <>
          <PageHero
            eyebrow="Beyond Academics"
            title="Arts"
            italic="— a dedicated cultural hub."
            image={`${ORIG}/beyond-acedemic-home-th.webp`}
            blurb={arts.intro}
          />

          <section className="bg-white py-14 md:py-20">
            <div className="max-w-[1200px] mx-auto px-5 md:px-10">
              <Reveal>
                <div className="text-center max-w-[700px] mx-auto mb-10 md:mb-12">
                  <div className="eyebrow mb-4">Arts Programmes</div>
                  <h2 className="h-section text-[var(--ink)]">
                    Where every child
                    <span className="serif-italic gold-text"> finds their stage.</span>
                  </h2>
                </div>
              </Reveal>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {arts.pillars.map((p, i) => (
                  <Reveal key={p.title} variant="zoom" delay={(i % 3) * 100}>
                    <div className="p-6 md:p-7 light-card h-full">
                      <div className="eyebrow mb-3">0{i + 1}</div>
                      <h3 className="serif text-[24px] md:text-[30px] text-[var(--ink)] leading-tight">
                        {p.title}
                      </h3>
                      <span className="gold-divider-thin block my-4" />
                      <p className="text-[14.5px] leading-[1.75] text-[var(--ink)]/75">{p.body}</p>
                    </div>
                  </Reveal>
                ))}
              </div>
              <Reveal>
                <div className="mt-12 md:mt-14 text-center">
                  <button onClick={openEnquire} className="btn-gold inline-flex items-center gap-2" style={{ background: "var(--gold)", color: "var(--navy-deep)" }}>
                    Enquire about Arts <ArrowUpRight size={16} />
                  </button>
                </div>
              </Reveal>
            </div>
          </section>

          <PullQuote
            tone="dark"
            text="Every child has a song. Our work is to listen, to nurture, and to give it a stage worth singing on."
          />

          <RelatedPages current="/arts.html" />
        </>
      )}
    </PageShell>
  );
}
